<template>
  <div ref="captchaStatsCard" class="stats-card-main">
    <h1>
      {{ title }}
    </h1>
    <p>{{ desc }}</p>

    <h2>
      {{ parseFloat(attr1).toFixed(2) }}
    </h2>

    <p>
      {{ attr2 }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ' '
    },
    desc: {
      type: String,
      default: ' '
    },
    attr1: {
      type: String,
      default: 'N/A'
    },
    attr2: {
      type: String,
      default: 'N/A'
    },
  },
  async mounted() {
    await this.sleep(10);
    this.$refs.captchaStatsCard.style = "transform: scale(1) !important";
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.stats-card-main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 180px;
  max-width: 28%;
  height: 180px;
  width: 28%;

  padding: 10px;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  padding-top: 25px;
  padding-left: 20px;
  transform: scale(0.5);
  transition: 0.4s;
}

.stats-card-main > h1 {
  font-size: 20px;
  color: #e0e0e0;
  text-align: left !important;
}

.stats-card-main > p {
  color: #888888;
  font-size: 12px;
}

.stats-card-main > p:nth-of-type(even) {
  text-align: center;
  width: 100%;
}

.stats-card-main > h2 {
  font-size: 42px;
  color: #ffffff;
  font-family: "OpenSans-SemiBold";
  margin-top: 24px;
  text-align: center;
  width: 100%;
}
</style>
